// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 2096); hand-edits allowed (see docs/architecture.md)

/** `this.SPEC_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_SPEC_DEF(): any {
  return [4, ["fast_walk", "sprotsman"], ["heavy_guy", "thinker"], ["crates", "less_tired"], ["crafting", "more_exp"]];
}
